import getCorePopUpStore from "../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import AddCommentPopUp from "./add-comment-pop-up";
import CleanPoolPopUp from "./clean-pool-pop-up";
import KhattabatClientAssignConfirmationPopUp from "./khattabat-client-assign-confirmation-pop-up";
import ReactivateKhattabaClientConfirmationPopUp from "./khattabat-reactivate-khattaba-client";
import ReactivateOneOTwoConfirmationPopUp from "./reactive-1o2-conv-pop-up";
import RemoveSilentBanPopUp from "./remove-silent-ban-pop-up";
import ResetAccountPopUp from "./reset-account-pop-up";
import ResetPasswordPopUp from "./reset-password-pop-up";
import WebPaymentPreviousRefundPopUp from "./web-payment-previous-refund-pop-up";
import WebPaymentRefundPopUp from "./web-payment-refund-pop-up";
import WebPaymentCancelPopUp from "./web-payment-cancel-pop-up";
import GiveSubscriptionConfirmationPopUp from "./give-subscription-confirmation-pop-up";
import TransferUserPackagePopUp from "./transfer-user-package-pop-up";

const Et3ConfirmationPopUp = withLiteObserverAndTheme(() => {
  const popUpType = getCorePopUpStore().confirmationPopUpType.get();

  switch (popUpType) {
    case "RESET_ACCOUNT_POPUP":
      return <ResetAccountPopUp />;
    case "REMOVE_SILENT_BAN_POPUP":
      return <RemoveSilentBanPopUp />;
    case "RESET_PASSWORD_POPUP":
      return <ResetPasswordPopUp />;
    case "ADD_COMMENT_POPUP":
      return <AddCommentPopUp />;
    case "WEB_PAYMENT_CANCEL_POPUP":
      return <WebPaymentCancelPopUp />;
    case "WEB_PAYMENT_REFUND_POPUP":
      return <WebPaymentRefundPopUp />;
    case "WEB_PAYMENT_PREVIOUS_REFUND_POPUP":
      return <WebPaymentPreviousRefundPopUp />;
    case "CLEAN_POOL_CONFIRMATION_POPUP":
      return <CleanPoolPopUp />;
    case "ONE_O_TWO_CONFIRMATION_POPUP":
      return <ReactivateOneOTwoConfirmationPopUp />;
    case "KHATTABAT_CLIENT_ASSIGN_CONFIRMATION_POPUP":
      return <KhattabatClientAssignConfirmationPopUp />;
    case "REACTIVATE_KHATTABA_CLIENT_POPUP":
      return <ReactivateKhattabaClientConfirmationPopUp />;
    case "GIVE_SUBSCRIPTION_CONFIRMATION_POPUP":
      return <GiveSubscriptionConfirmationPopUp />;
    case "TRANSFER_USER_PACKAGE_POPUP":
      return <TransferUserPackagePopUp />;
    default:
      return <></>;
  }
});
export default Et3ConfirmationPopUp;
